<p-dialog
  [header]="getHeader()"
  [(visible)]="visible"
  [style]="{ width: '100%', maxWidth: '650px' }"
  [contentStyle]="{ minHeight: 'auto' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [focusOnShow]="false"
>
  <div class="flex flex-column gap-3">
    <p-messages [(value)]="messages" [enableService]="false" [closable]="false"></p-messages>

    <eo-form
    #eoForm
    [config]="getFormConfig()"
    (formSubmit)="onSubmit($event)"
    [submitButtonLoading]="isSubmitLoading()"
    >
    <!-- [submitButtonLoading]="isSubmitLoading()"  -->

  </eo-form>
</div>
</p-dialog>
